import React from "react";
import { Text } from "../../atoms/Text/Text";
import { Button } from "../../atoms/Buttons/Base";
import { FriendUserInfo } from "../../models/FriendModel";
import classNames from "classnames";

import styles from "./FriendContainer.css";
import { FriendTabs } from "../../services/Friend/FriendService";

type RenderUserRowsProps = {
  list: any;
  tabId: FriendTabs;
  isOpened: boolean;
  onClickRemove: (
    user: FriendUserInfo,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
};

export class RenderUserRows extends React.Component<RenderUserRowsProps> {
  renderList() {
    const { list } = this.props;

    return list.slice(0, 10).map((user: FriendUserInfo, ind) => (
      <React.Fragment key={ind}>
        <tr>
          <td>
            <UserName>{user.name}</UserName>
          </td>
          <td align="right">
            <RemoveButton onClick={() => this.props.onClickRemove(user, null)}>
              <Text size="sm" style={{ padding: "2px" }}>
                x Remove
              </Text>
            </RemoveButton>
          </td>
        </tr>
        <tr>
          <td className={styles.hrRow} colSpan={2}>
            <HR />
          </td>
        </tr>
      </React.Fragment>
    ));
  }

  render() {
    const { tabId, isOpened } = this.props;
    return (
      <table>
        <thead>
          <tr>
            <th colSpan={2} align={"center"}>
              <Text color="accentLight" align="center" as="div">
                Edit your network
              </Text>
            </th>
          </tr>
        </thead>
        <tbody
          role="tabpanel"
          className={classNames(styles.tbody__global, {
            [styles.hiddenFriendTable]: !isOpened,
          })}
          id={tabId}
          aria-labelledby={`tab${tabId}`}
        >
          {this.renderList()}
        </tbody>
      </table>
    );
  }
}

const RemoveButton = (props: any) => (
  <Button
    className={classNames(styles.tabRemove, styles.removeButton)}
    {...props}
  />
);
const HR = (props: any) => <hr className={styles.hr} {...props} />;
const UserName = (props: { you?: boolean; [key: string]: any }) => (
  <Text
    className={classNames(styles.userName, { [styles.userNameYou]: props.you })}
    {...props}
  />
);
